'use client';

import { Video } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useVideoRecording } from '../video-recording-provider';

export function ErrorView() {
	const { uiState, setUIState, openCamera } = useVideoRecording();

	return (
		<div className="flex flex-col items-center justify-center rounded-xl bg-red-50 p-6 text-center shadow-sm">
			<div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
				<Video className="h-6 w-6 text-red-600" />
			</div>
			<h3 className="mb-2 text-base font-semibold text-red-900">
				Camera & Microphone Access Required
			</h3>
			<p className="mb-4 max-w-sm text-sm text-red-700">{uiState.error}</p>

			<div className="flex w-full gap-3">
				<Button
					type="button"
					variant="outline"
					className="flex-1 border-primary hover:bg-transparent"
					onClick={() => {
						setUIState((prev) => ({ ...prev, error: null, state: 'initial' }));
					}}
				>
					Cancel
				</Button>
				<Button
					type="button"
					variant="default"
					className="flex-1"
					onClick={async () => {
						setUIState((prev) => ({ ...prev, error: null, state: 'initial' }));
						await openCamera('try_again');
					}}
				>
					<Video className="mr-2 h-4 w-4" />
					Try Again
				</Button>
			</div>
		</div>
	);
}
